import { message } from "antd";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";
// import { useSelector } from "react-redux";

export const fetchPackage = async (setPackage, baseUrl, prodTestUrl) => {
  // const baseUrl = useSelector(selectBaseUrl);
  // const prodTestUrl = useSelector(selectProdTestUrl);
  try {
    const response = await fetch(
      `${prodTestUrl ? prodTestUrl : baseUrl}/api/admin-get-all-packages/`
    );
    if (response.ok) {
      const data = await response.json();
      setPackage(data);
    } else {
      message.error("Failed to fetch package.");
    }
  } catch (error) {
    message.error("An error occurred while fetching package.");
  }
};